<template>
  <div>
    <div class=" mainLoader" v-if="loading">
    </div>
    <div class="realbody">
      <div class="top_summary">
        <div class="container">
          <div class="row">
            <div class="col-md-6" style="padding: 70px 0px;">
              <p class="top_summary_header mplus2p-m spacing4 noiseblack">{{$t('cp_title')}}</p>
              <p class="top_summary_comment mplus2p-r spacing1-2 noiseblack">{{$t('cp_desc')}}</p>
            </div>
            <div class="col-md-6" style="text-align: center;">
              <img src="../../assets/imgs/companyprofile.png" class="pman" />
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row" style="margin-top: 40px;">
          <div class="col-md-3">
            <app-company-sidebar :selectedItem="selectedItem"></app-company-sidebar>
          </div>
          <div class="col-md-9">
            <div class="row">
              <div class="col-md-6">
                  <div class="page_title">
                    <span class="page_title_comment mplus2p-m spacing1-2 noiseblack">{{$t('company_page')}}</span>
                  </div>
              </div>
              <div class="col-md-6 pr-0">
                  <v-popover class="float-right custom-pop" style="margin-left:10px;width::auto;margin-top:15px"
                      placement="top"
                      popoverBaseClass="tooltip pop_up"
                      offset="5"
                      >
                        <span class="tooltip-target">
                        <i class="fa fa-info-circle" ></i></span>
                        <template slot="popover">
                          <p style="text-align:justify;padding:0 15px"><span style="color:#3d7dd8;font-weight:700">{{$t('popover_desc1')}}</span> {{ $t('popover_desc2') }}</p>
                          <p style="text-align:justify;padding:0 15px"><span style="color:#3d7dd8;font-weight:700">{{$t('popover_desc3')}}</span> {{ $t('popover_desc4') }}</p>
                          <p style="text-align:justify;padding:0 15px">{{ $t('popover_desc5') }}</p>
                        </template>
                      </v-popover>
                      <div class="float-right mt-3">
                           <span v-if="membership_paln == 'MEMBER'" class="primary">{{membership_paln}}</span>
                          <span v-else class="success">{{membership_paln}}</span>
                      </div>

              </div>
            </div>
            <div class="row pview">
              <div class="col-md-3 text-center">
                  <video v-if="c_video"   height="150" width="150" controls autoplay loop>
                    <source :src="c_video">
                  </video>

                  <img v-if="c_image" class="avatar" :src="c_image" />

              </div>
              <div class="col-md-9">
                <div class="col-md-12" style="height: 15px;"></div>
                <div class="row">
                  <div class="col-md-4">
                    <label class="pgraytxt mplus2p-m spacing1-2 noiseblack ">{{$t('cp_name')}}</label>
                  </div>
                  <div class="col-md-8">
                    <p class="mplus2p-m spacing1-2 noiseblack">{{c_name}}</p>
                  </div>
                </div>
                <div v-if="c_location" class="row">
                  <div class="col-md-4">
                    <label class="pgraytxt mplus2p-m spacing1-2 noiseblack">{{$t('cp_location')}}</label>
                  </div>
                  <div class="col-md-8">
                    <p class="mplus2p-m spacing1-2 noiseblack">{{c_location}}</p>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <label class="pgraytxt mplus2p-m spacing1-2 noiseblack">{{$t('cp_e_url')}}</label>
                  </div>
                  <div class="col-md-8">
                    <p class="mplus2p-m spacing1-2 noiseblack link" @click="navigateToUrl(c_enterprise_url)">
                      {{c_enterprise_url}}</p>
                  </div>
                </div>
              </div>
              <div class="col-md-12 pheaderpanel slide_options">
                <div class="row">
                  <div class="col-md-6 slide_item spressed wrapper1 " id="s1" @click="pressed_slide(1)">
                    <span class="slide_txt mplus2p-r spacing1-4">{{$t('cp_basic_info')}}</span>
                  </div>
                  <div class="col-md-6 slide_item wrapper1" id="s2" @click="pressed_slide(2)">
                    <span class="slide_txt mplus2p-r spacing1-4">{{$t('ep_engineer_notification')}}</span>
                  </div>
                </div>
              </div>
              <div class="container">
                <div class="row pview " id="basic_info">
                  <template v-if="c_esablishment">
                    <div class="col-md-12" style="height: 15px;"></div>
                    <div class="col-md-4">
                      <p class="pgraytxt mplus2p-m spacing1-2 noiseblack pvlabel">{{$t('cp_establishment')}}</p>
                    </div>
                    <div v-if="c_esablishment != null " class="col-md-8">
                      <p v-if="lan == 'en'" class="mplus2p-m spacing1-2 noiseblack">{{c_esablishment}}</p>
                      <p v-if="lan == 'jp'" class="mplus2p-m spacing1-2 noiseblack">{{c_esablishment}}</p>
                    </div>
                  </template>

                  <template v-if="c_representative">
                    <div class="col-md-12" style="height: 15px;"></div>
                    <div class="col-md-4">
                      <p class="pgraytxt mplus2p-m spacing1-2 noiseblack pvlabel">{{$t('cp_representative')}}</p>
                    </div>
                    <div class="col-md-8">
                      <p class="mplus2p-m spacing1-2 noiseblack">{{c_representative}}</p>
                    </div>
                  </template>

                  <template v-if="c_NOE">
                    <div class="col-md-12" style="height: 15px;"></div>
                    <div class="col-md-4">
                      <p class="pgraytxt mplus2p-m spacing1-2 noiseblack pvlabel">{{$t('cp_noe')}}</p>
                    </div>
                    <div class="col-md-8">
                      <p class="mplus2p-m spacing1-2 noiseblack">{{c_NOE}}</p>
                    </div>
                  </template>

                  <template v-if="c_desc">
                    <div class="col-md-12" style="height: 15px;"></div>
                    <div class="col-md-4">
                      <p class="pgraytxt mplus2p-m spacing1-2 noiseblack pvlabel">{{$t('cp_company_desc')}}</p>
                    </div>
                    <div class="col-md-8">
                      <pre class="cs_summary mplus2p-m spacing1-2 noiseblack" style="height: auto;text-align:justify;white-space:pre-wrap;" v-html="urlify(c_desc)"></pre>
                    </div>
                  </template>

                  <template v-if="c_recruitment_situation">
                    <div class="col-md-12" style="height: 15px;"></div>
                    <div class="col-md-4">
                      <p class="pgraytxt mplus2p-m spacing1-2 noiseblack pvlabel">{{$t('recruitment_situation')}}</p>
                    </div>
                    <div v-if="c_recruitment_situation != null " class="col-md-8">
                      <p v-if="lan == 'en'" class="mplus2p-m spacing1-2 noiseblack">
                        {{c_recruitment_situation.en_situation}}</p>
                      <p v-if="lan == 'jp'" class="mplus2p-m spacing1-2 noiseblack">
                        {{c_recruitment_situation.jp_situation}}</p>
                    </div>
                  </template>

                  <template v-if="c_benefits.length > 0">
                    <div class="col-md-12" style="height: 15px;"></div>
                    <div class="col-md-4">
                      <p class="pgraytxt mplus2p-m spacing1-2 noiseblack pvlabel">{{$t('benefit')}}</p>
                    </div>

                    <div class="col-md-8">
                      <div class="tech2">
                        <span class="layer2" v-for="(item, index) of c_benefits" :key="index">{{ lan == 'en'? item.en_benefit:item.jp_benefit}}</span>
                      </div>
                    </div>
                  </template>

                  <template v-if="c_ratio_of_engineer">
                    <div class="col-md-12" style="height: 15px;"></div>
                    <div class="col-md-4">
                      <p class="pgraytxt mplus2p-m spacing1-2 noiseblack pvlabel">{{$t('ratio_of_engineer')}}</p>
                    </div>
                    <div v-if="c_ratio_of_engineer != null " class="col-md-8">
                      <p v-if="lan == 'en'" class="mplus2p-m spacing1-2 noiseblack">{{c_ratio_of_engineer.en_ratio}}</p>
                      <p v-if="lan == 'jp'" class="mplus2p-m spacing1-2 noiseblack">{{c_ratio_of_engineer.jp_ratio}}</p>
                    </div>
                  </template>


                  <div class="col-md-12" style="height: 38px;"></div>

                  <div v-if="role != 'engineer'" class="col-md-12 pv_btnpanel">
                    <router-link :to="{ name: 'companyProfileEdit', params: {cid: this.$route.params.cid, uid: this.$route.params.uid} }">
                      <button class="btn bluebtn updatebtn">{{$t('cp_button')}}</button>
                    </router-link>
                  </div>
                </div>
              </div>
              <div class="container">
                <div class="row eview" id="score_info">
                    <div class="col-md-12" style="height: 30px;"></div>
                    <div class="col-md-12">
                      <form @submit.prevent="doSendEngineerNotification()">
                        <div class="row">
                            <div class="col-md-4">
                              <p class="pgraytxt mplus2p-m spacing1-2 noiseblack pvlabel">{{$t('ep_engineer_notification')}}</p>
                            </div>
                            <div  class="col-md-8">
                                <textarea type="text" class="peditboxes peditinput form-control" name="lastname" v-model="engineer_notification" autofocus :placeholder="$t('ep_engineer_notification')" rows="5" ></textarea>
                            </div>
                        </div>
                        <div class="row">
                          <div class="col-md-12" style="height: 30px;"></div>
                          <div v-if="role != 'engineer'" class="col-md-12 pv_btnpanel">
                              <button class="btn bluebtn updatebtn">{{$t('sk_save_btn_lb')}}</button>
                          </div>
                        </div>
                      </form>
                    </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import companySidebar from "./company_sidebar";
import axios from "axios";
import { EventBus } from "../../main.js";

export default {
  data() {
    return {
      selectedItem: 1,
      loading: false,
      role: "",

      engineer_notification: '',

      c_name: "",
      c_image: "",
      c_video: "",
      c_location: "",
      c_esablishment: "",
      c_representative: "",
      c_enterprise_url: "",
      c_NOE: "",
      c_desc: "",
      c_recruitment_situation: "",
      c_benefits: "",
      c_ratio_of_engineer: "",
      c_recruitment_tension: "",
      c_freelance_type: "",
      c_contract_type: "",
      c_why_hire_engineer: "",

      membership_paln: '',

      companyId: "",
      userId: "",

      uId: "",
      cId: "",

      lan: "jp",
      panelid: 1
    };
  },
  components: {
    appCompanySidebar: companySidebar
  },
  mounted() {
    EventBus.$on("language", data => {
      this.lan = data;
    });
    this.role = localStorage.getItem("role");
    this.doCenter();
    this.pressed_slide(this.panelid);
  },
  created() {
    if ("lan" in localStorage) {
      this.lan = localStorage.getItem("lan");
    }
    var data = JSON.parse(localStorage.getItem("user"));
    var uId = data.user_token;
    var cId = data.company.company_token;
    this.userId = data.id;
    this.companyId = data.company.id;

    if (uId != this.$route.params.uid || cId != this.$route.params.cid) {
      this.$router.push("/global/PageNotFound");
    }
    this.companyProfile(this.companyId);
    this.engineerNotification();
  },
   computed: {
    onResize(event) {
      this.doCenter();
    },
  },
  methods: {
    doSendEngineerNotification(){
      this.loading = true;
        const thisVue = this;
        const formData = {
          engineer_notification: this.engineer_notification
        };
        axios
          .post("/save-engineer-notification?token=" + localStorage.getItem("token"), formData, {
            headers: {"X-localization": localStorage.getItem("lan")}
          })
          .then(res => {
            if (!res.data.result) {
              this.$toaster.error(res.data.data.message);
              this.loading = false;
            } else {
              this.loading = false;
              this.$toaster.success(thisVue.$t("success_engineer_notification"));
              this.engineer_notification = res.data.engineer_notification;
            }
          })
          .catch(() => {
            this.$toaster.error(thisVue.$t("err_network"));
          });

    },
    urlify(text) {
      var urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g;
      //var urlRegex = /(https?:\/\/[^\s]+)/g;
      return text.replace(urlRegex, function(url,b,c) {
          var url2 = (c == 'www.') ?  'http://' +url : url;
          return '<a href="' +url2+ '" target="_blank">' + url + '</a>';
      })
    },
    engineerNotification(){
      const thisVue = this;
      axios
          .get("/engineer-notification?token=" + localStorage.getItem("token") ,{
            headers: {"X-localization": localStorage.getItem("lan")}
          })
          .then(res => {
            if (!res.data.result) {
              this.$toaster.error(res.data.data.message);
            } else {
              this.engineer_notification = res.data.engineer_notification;
            }
          })
          .catch(() => {
            this.$toaster.error(thisVue.$t("err_network"));
          });
    },
     doCenter() {
      let txtheight, txtwidth;
      if ($(window).width() <= 975 && $(window).width() >= 751) {
        $("#total").css("font-size", "1rem");
        $("#technical").css("font-size", "1rem");
        $("#management").css("font-size", "1rem");
        $("#business").css("font-size", "1rem");
        txtwidth = [10.44, 20.88, 31.3];
        txtheight = 40;
      } else {
        $("#total").css("font-size", "1.5rem");
        $("#technical").css("font-size", "1.5rem");
        $("#management").css("font-size", "1.5rem");
        $("#business").css("font-size", "1.5rem");
        txtwidth = [15.66, 31.3, 46.95];
        txtheight = 28;
      }
    },
     pressed_slide(id) {
      this.panelid = id;
      $(".wrapper1").removeClass("spressed");
      $("#s" + id).addClass("spressed");
      if (this.panelid === 1) {
        $("#basic_info").css("display", "flex");
        $("#score_info").css("display", "none");
      }
      if (this.panelid === 2) {
        $("#score_info").css("display", "contents");
        $("#basic_info").css("display", "none");
        this.doCenter();
      }
    },
    companyProfile(id) {
      this.loading = true;
      axios
        .get("/company/" + id + "?token=" + localStorage.getItem("token"), {
          headers: { "X-localization": localStorage.getItem("lan") }
        })
        .then(res => {
          if (res.data[0]) {
            this.$toaster.error(res.data[0]);
            this.$store.dispatch("logout");
          }
          if (!res.data.result) {
            for (var i = 0; i < res.data.errors.length; i++) {
              this.$toaster.error(res.data.errors[i].message);
            }
            this.loading = false;
          } else {
            this.c_name = res.data.company.name;
            if (res.data.company.image.split(/\#|\?/)[0].split('.').pop().trim() === 'mp4') {
              this.c_video = res.data.company.image
            }else{
              this.c_image = res.data.company.image;
            }
            this.c_location = res.data.company.location;

            this.c_esablishment = res.data.company.establishment_year;
            this.c_representative = res.data.company.representative;
            this.c_enterprise_url = res.data.company.enterprise_url;
            this.c_NOE = res.data.company.number_of_employees;
            this.c_desc = res.data.company.company_description;
            this.membership_paln = res.data.company.membership_plan
            this.c_recruitment_situation =
              res.data.company.recruitment_situation;
            if (res.data.company.benefits != null) {
              var benefits = res.data.company.benefits.sort(function(a, b) {
                return a.id - b.id;
              });
              this.c_benefits = benefits;
            }
            this.c_ratio_of_engineer = res.data.company.ratio_of_engineer;
            this.c_recruitment_tension = res.data.company.recruitment_tension;
            this.c_freelance_type = res.data.company.freelance_type;
            this.c_contract_type = res.data.company.contract_type;
            this.c_why_hire_engineer = res.data.company.why_hire_engineer;
            this.loading = false;
          }
        })
        .catch(error => console.log(error));
    },
    navigateToUrl(url) {
      window.open(url, "_blank");
    }
  }
};
</script>

<style scoped>
.success{
  border-radius: 5px;
  padding: 8px;
  color: #fff;
  background-color: #28a745;
  border-color: #28a745;
}
.primary{
  border-radius: 5px;
  padding: 8px;
  color: #fff;
  background-color: #007bff;
  border-color: #007bff;
}
.custom-control.material-switch {
  --color: #3d7dd8;
  padding-left: 0;
}
.custom-control.material-switch .material-switch-control-input {
  display: none;
}
.custom-control.material-switch .material-switch-control-input:checked ~ .material-switch-control-indicator::after {
  background-color: var(--color);
  left: 17px;
}
.custom-control.material-switch .material-switch-control-indicator {
  display: inline-block;
  position: relative;
  margin: 0 10px;
  top: 4px;
  width: 32px;
  height: 16px;
  background: #ddd;
  border-radius: 16px;
  transition: .3s;
}
.custom-control.material-switch .material-switch-control-indicator::after {
  content: '';
  display: block;
  position: absolute;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  transition: .3s;
  top: -1px;
  left: -1px;
  background: #fdfdfd;
  box-shadow: 0 2px 10px #aaa;
}


.tech2 {
  margin-right: 5px;
  margin-bottom: 10px;
}

.layer2 {
  border: 2px solid #3d7dd8;
  font-size: 0.7rem;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: 1.4px;
  color: #3d7dd8;
  padding: 5px;
  margin-right: 5px;
  white-space: pre;
  word-break: keep-all;
  display: inline-block;
  border-radius: 5px;
  margin-bottom: 10px;
}
.pman {
  width: auto;
  margin-top: 70px;
}

.slide_options {
  background-color: #f8fafa;
  border-radius: 30px;
  margin: 10px 0px;
  margin-top: 44px;
  padding: 5px 0px;
}

.slide_item {
  text-align: center;
  padding: 18px;
  cursor: pointer;
}

.spressed {
  text-align: center;
  padding: 18px;
  border-radius: 30px;
  background-color: #ffffff;
  box-shadow: 0 1px 2px 0 rgba(40, 60, 80, 0.12);
}

.slide_txt {
  font-size: 1rem;
  font-weight: bold;
  color: #b4bec8;
}

.spressed .slide_txt {
  font-size: 1rem;
  font-weight: bold;
  color: #3d7dd8;
}

.pview {
  margin-top: 38.5px;
  margin-bottom: 80px;
}

.avatar {
    width: 147px;
    height: 147px;
    object-fit: contain;
    object-position:center;
    border-radius: 10px;
}

.pgraytxt {
  opacity: 0.64;
  font-size: 1rem;
  font-weight: 500;
}

.cs_summary {
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.5;
  word-wrap: break-word;
}

.pvlabel {
  margin-left: 20px;
}

.pv_btnpanel {
  padding: 0px 10%;
}

.updatebtn {
  width: 100%;
  height: 56px;
}

.pv_showchart {
  background-color: #f8f8fa;
  margin-top: 16px;
}

.eview {
  padding: 30px 15px;
}

.chartboxes {
  display: block;
  margin: auto;
  margin-bottom: 30px;
  max-width: 200px;
  height: 100px;
}

.statustitle {
  font-size: 1.25rem;
  font-weight: bold;
  margin-top: 34px;
  margin-bottom: 0.1rem;
}

.statusnum {
  position: absolute;
  /*right: 46%;
      top: 55%;*/
  font-weight: bold;
  font-size: 1.5rem;
}

.caltxt {
  margin-top: 45px;
}

.calpanel {
  text-align: right;
}

.pheaderpanel {
  margin: 0px 20px;
  margin-top: 30px;
}

.link {
  cursor: pointer;
  color: blue;
}
.link:hover {
  text-decoration: underline;
}

@media screen and (max-width: 768px) {
  .pman {
    margin-top: 0px;
  }

  .avatar {
    width: 50%;
  }

  .page_title {
    margin-top: 40px;
  }

  .pvlabel {
    margin-left: 0px;
  }

  .calpanel {
    text-align: center;
  }

  .pheaderpanel {
    margin: 0px;
    margin-top: 30px;
  }
}
</style>
